import { render, staticRenderFns } from "./PrecificationRulesController.vue?vue&type=template&id=bc87af98"
import script from "./PrecificationRulesController.vue?vue&type=script&lang=js"
export * from "./PrecificationRulesController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports